import clsx from "clsx";
import Button from "components/Button/Button";
import FormInput from "components/Inputs/FormInput";
import { t } from "i18next";
import { useAccountContext } from "providers/AccountProvider";
import { RssContext, useRssContext } from "providers/RssProvider";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { RssService } from "service/rss.service";

export const RssFilter = () => {
    const [rssItems, setRssItems] = useState<any[]>([]);
    const [activeElement, setActiveElement] = useState("");
    const { accountObj } = useAccountContext() as any;
    const { setRssFilters, rssFilters } = useRssContext() as any;

    const getRssFeeds = async (CompanyId: any) => {
        const data = await RssService.getRssFeeds(CompanyId);
        setRssItems(data.filter((item: any) => item.isDeletable === true));
    };

    useEffect(() => {
        const { companyId } = accountObj.account;
        getRssFeeds(companyId);
    }, []);

    const onClick = (item: any) => {
        const { url: RssUrl, id: Id } = item;
        if (Id === activeElement) {
            setActiveElement("");
        } else {
            setActiveElement(Id);
        }
        if (!rssFilters.includes(RssUrl)) {
            setRssFilters([RssUrl]);
        } else {
            setRssFilters(rssFilters.filter((item: any) => item !== RssUrl));
        }
    };

    return (
        <div className="rss-filters">
            {rssItems.map((item: any, idx: number) => (<div key={idx} className={clsx(activeElement === item.id && "active")} onClick={() => onClick(item)}>{item.name}</div>))}
        </div>
    );
};
